import type { RailwayProjectSummary, RailwayWorkspace } from '@cli-types/next-adapter/railway.js'
import { isNonEmptyString } from '@cli-utils/shared.js'

export function parseProjectSummary(value: unknown): RailwayProjectSummary | undefined {
  if (!value || typeof value !== 'object') return undefined
  const project = value as Record<string, unknown>
  if (!isNonEmptyString(project.id) || !isNonEmptyString(project.name)) return undefined

  const workspaceValue = project.workspace
  let workspace: RailwayWorkspace | undefined
  if (workspaceValue && typeof workspaceValue === 'object') {
    const candidate = workspaceValue as Record<string, unknown>
    if (isNonEmptyString(candidate.id) && isNonEmptyString(candidate.name)) {
      workspace = { id: candidate.id, name: candidate.name }
    }
  }

  return { id: project.id, name: project.name, workspace }
}
